import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button';

import { Link } from 'react-router-dom';

import { CityLogo } from '../ui/icons';

class Header extends Component {
    render() {
        return (
            <AppBar
                position="fixed"
                style={{
                    backgroundColor:'#98c5aa',
                    boxShadow: 'none',
                    padding:'10px 0',
                    borderBottom: '2px solid #00285e'
                }}
            >
                <Toolbar style={{display:'flex'}}>
                    <div style={{flexGrow: 1}}>
                        <div className="header_logo">
                            <CityLogo
                                width="70px"
                                height="70px"
                            />
                        </div>  
                    </div>
                    {/* <Link to="/sign_in">
                        <Button color="inherit">Login</Button>
                    </Link>
                    <Link to="/dashboard">
                        <Button color="inherit">Dashboard</Button>
                    </Link> */}

                </Toolbar>
            </AppBar>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header_footer/Header.js